<template>
    <header class="fixed h-16 md:h-20 bg-white lg:bg-transparent flex w-full top-0 left-0 z-30 pointer-events-none">

        <div class="fixed top-3 left-3 md:top-4 md:left-4 lg:top-2 lg:left-2 flex">
            <btn-summary/>
            <btn-search/>
        </div>

        <div class="fixed top-3 right-3 md:top-4 md:right-4 lg:top-2 lg:right-2 flex ">
            <btn-diaporama/>
            <icon-edf-mobile/>
        </div>

    </header>
</template>

<script> 
export default {
    name: "Header",
    methods: {
        headerDynamicAdjust() {
                let isMobile = window.matchMedia("(max-width: 1024px)").matches;
                if (isMobile) {
                    $(document).ready(function () {
                        var headerHeight = $(".header-container > .mobile").height() + "px";
                        $(".catalogue").css("padding-top", headerHeight);
                    });
                }
                if (!isMobile) {
                    $(".catalogue").css("padding-top", 0);
                }
            }
    },
    mounted() {
         window.addEventListener("resize", this.headerDynamicAdjust);
            this.headerDynamicAdjust();
    }
}
</script>

<style scoped lang="scss">
//header {
//    height: $header_height;
//}
</style>
